import { combineReducers } from 'redux'

import { auth, AuthState } from './auth'
import { loading, LoadingState } from './loading'
import { popup, PopupState } from './popup'
import { progressBar, ProgressBarState } from './progressBar'
import { projects, ProjectsState } from './projects'
import { toaster, ToasterState } from './toaster'

export const reducers = combineReducers({
  auth,
  loading,
  progressBar,
  toaster,
  popup,
  projects,
})

export interface State {
  auth: AuthState
  loading: LoadingState
  progressBar: ProgressBarState
  toaster: ToasterState
  popup: PopupState
  projects: ProjectsState
}
